<app-header-one [class]="'header-gym'" [searchbar]="searchbar" (searchQuery)="updateSearch($event)"></app-header-one> <!--[searchbar]="searchbar" (searchQuery)="updateSearch($event)"></app-header-one-->
<!--app-subheader [title]="'Ordina a domicilio'"></app-subheader-->
<!-- <app-separator [size]="'lg'"></app-separator> -->
<!--section class="p-0 gym-slider">
    <h1>Ordina a domicilio</h1>
    <div class="container border-0 text-center">
        <p *ngIf="location">{{ location.description }}</p>
        <button class="btn btn-solid btn-block btn-sm mx-auto mt-4 w-auto btn-outline" (click)="editLocation()">Modifica</button>
        <a (click)="openAllegerni()">Informazioni sugli allergeni</a>
    </div>
</section-->
<!-- section start -->
<section class="section-b-space pt-0">
    <div class="collection-wrapper">
        <div class="container py-5">
            <div class="row my-5 justify-content-end d-block d-md-none">  
                <div class="col-12 left-sidebar">              
                    <app-navigation-bar></app-navigation-bar>
                    <h1 class="mt-4">
                        <span *ngIf="isLogged; else nologin">Ciao {{user.name}}!</span>
                        <ng-template #nologin>Benvenuto!</ng-template>
                    </h1>
                    <div class="mb-5">
                        <h4 *ngIf="service == 0">Ora della consegna:</h4>
                        <h4 *ngIf="service == 1">Ora del ritiro:</h4>
                        <h3>
                            <span *ngIf="order_date.length && order_date !== '-2'; else noDate;">
                                <ng-container *ngIf="order_date !== 'FAST'; else fast">{{order_date}}</ng-container>
                                <ng-template #fast>Appena possibile</ng-template>
                            </span>
                            <ng-template #noDate>Orario</ng-template>
                        </h3>
                        <button class="button-primary-text" (click)="changeDatetime()">
                            Modifica
                            <img src="assets/icons/freccia.svg">
                        </button>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 " *ngIf="related && related.length">
                    <!-- banner mixa i menu -->
                    <h4 class="title title-lime">Mixa i menu</h4>
                    <div class=" d-flex align-items-center">
                        <!-- <div class="promo-banner" *ngIf="leftArrowHide">  
                            <a (click)="scrollLeft()" class="arrow-container" [ngClass]="{'display': leftArrowHide}">
                                <img src="assets/images/frecciav.png"/>
                            </a>          
                        </div> -->
                        <div id="mix-items" #mixScroll  class="promo-banner">  
                                    
                            <a [routerLink]="['/ristoranti/', rec.slug]" class="promo-container" *ngFor="let rec of related" (click)="goToRestaurant(rec)">
                                <div class="card">
                                    <div class="card-body" [ngStyle]="{'background-image': 'url('+ appInfo.ASSETS_URL + rec.mediaheader.filename + ')'}"></div>
                                </div>
                                <h5 class="pl-2">{{rec.name}}</h5>
                            </a> 
                            
                        </div>   
                        <!-- <div  class="promo-banner"  *ngIf="rightArrowHide">                          
                            <a  (click)="scrollRight()" class="arrow-container" [ngClass]="{'display': rightArrowHide}">
                                <img src="assets/images/frecciavr.png"/>
                            </a>   
                        </div>  -->
                    </div>
                </div>
            </div>


            <div class="row my-5 justify-content-end">
                <div class="col-xl-3 col-lg-3 col-md-6 pl-5 left-sidebar d-none d-md-block">
                    <h1 class="my-2">Food</h1>
                    <app-navigation-bar></app-navigation-bar>
                    <img class="logo-img" src="assets/images/merlata/logo.svg">
                    <h1 class="mt-4">
                        <span *ngIf="isLogged; else nologin">Ciao {{user.name}}!</span>
                        <ng-template #nologin>Benvenuto!</ng-template>
                    </h1>
                    <div class="mb-5">
                        <h4 *ngIf="service == 0">Ora della consegna:</h4>
                        <h4 *ngIf="service == 1">Ora del ritiro:</h4>
                        <h3>
                            <span *ngIf="order_date.length && order_date !== '-2'; else noDate;">
                                <ng-container *ngIf="order_date !== 'FAST'; else fast">{{order_date}}</ng-container>
                                <ng-template #fast>Appena possibile</ng-template>
                            </span>
                            <ng-template #noDate>Orario</ng-template>
                        </h3>
                        <button class="button-primary-text" (click)="changeDatetime()">
                            Modifica
                            <img src="assets/icons/freccia.svg">
                        </button>
                    </div>
                    <div class="searchbar-header d-md-block d-none my-3" *ngIf="searchbar && searchbar.query != null">
                      <img src="assets/icons/lente.svg">
                      <input class="form-control" [(ngModel)]="searchbar.query" (ngModelChange)="updateSearch(searchbar.query)" [placeholder]="searchbar.placeholder">
                    </div>                    
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-12">  
                    <h1 class="eit-act-title mx-2 my-4 d-lg-none">
                        {{restaurant.name}}
                    </h1>
                    <img class="header-img my-4" [src]="headerImg">
                    <!-- <div class="header-rest" [ngStyle]="{'background-image': 'url('+ headerImg +')'}"></div> -->
                    <div class="info-col d-lg-none">
                        <p class="text-color-secondary m-2">
                          <span *ngFor="let cucina of restFull?.cucine_full; let i = index"><span *ngIf="i > 0">/</span>{{cucina.name}}</span>
                        </p>   
                        <p class="text-color-dark m-2" *ngIf="restFull && restFull.phone && restFull.phone.length">
                            <!-- {{restFull.address}}, {{restFull.num}}<br/> -->
                           
                            Tel. {{restFull.phone}}
                        </p>
                        <p class="text-color-accent m-2" *ngIf="!restaurant?.message_event && !restaurant?.nowclosed && !restaurant?.day_closed">
                            <ng-container *ngIf="service == 0">Consegna</ng-container><ng-container *ngIf="service == 1">Ritiro</ng-container> in 30 minuti
                        </p>
                        <p class="text-color-accent2 m-2" *ngIf="!restaurant?.message_event && restaurant?.nowclosed && !restaurant?.day_closed && !restaurant?.preorder">
                            Torno presto
                        </p>
                        <p class="text-color-accent2 m-2" *ngIf="!restaurant?.message_event && restaurant?.day_closed">Torno presto</p>
                        <p class="m-2" *ngIf="!restaurant?.message_event && restaurant?.nowclosed && !restaurant?.day_closed && restaurant?.preorder && !restaurant?.ordinabiledomani">
                            Disponibile dalle <ng-container *ngIf="service == 0; else nextopenta">{{restaurant?.next_open}}</ng-container><ng-template #nextopenta>{{restaurant?.next_open_takeaway}}</ng-template>
                        </p>
                        <p class="text-color-accent2 m-2" *ngIf="!restaurant?.message_event && restaurant?.nowclosed && !restaurant?.day_closed && restaurant?.preorder && restaurant?.ordinabiledomani">
                            Per domani
                        </p>
                        <p class="text-color-accent2 m-2" *ngIf="restaurant?.message_event">{{restaurant?.message_event}}</p>
    
                        <p class="text-color-dark m-2" *ngIf="service == 0 && cartData && cartData.order">
                            Consegna {{cartData.order.euro_delivery.toFixed(2)}} &euro;
                        </p>
                        <div class="label-fill m-2" *ngIf="restaurant?.interno" [innerHTML]="restaurant.interno"></div>
                        <p class="text-color-dark m-2 mt-5">Puoi consultare il libro degli allergeni direttamente in store</p>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 info-col d-none d-lg-block">  
                    <h1 class="eit-act-title mx-2 my-4">
                        {{restaurant.name}}
                    </h1>
                    <p class="text-color-secondary m-2">
                      <span *ngFor="let cucina of restFull?.cucine_full; let i = index"><span *ngIf="i > 0">/</span>{{cucina.name}}</span>
                    </p>   
                    <p class="text-color-dark m-2" *ngIf="restFull && restFull.phone && restFull.phone.length">
                        <!-- {{restFull.address}}, {{restFull.num}}<br/> -->
                       
                        Tel. {{restFull.phone}}
                    </p>
                    <ng-container *ngIf="service == 0; else istakeaway">
                        <p class="text-color-accent m-2" *ngIf="!restaurant?.message_event && !restaurant?.nowclosed && !restaurant?.day_closed">
                            Consegna in 30 minuti
                        </p>
                        <p class="text-color-accent2 m-2" *ngIf="!restaurant?.message_event && restaurant?.nowclosed && !restaurant?.day_closed && !restaurant?.preorder">
                            Torno presto
                        </p>
                        <p class="text-color-accent2 m-2" *ngIf="!restaurant?.message_event && restaurant?.day_closed">Torno presto</p>
                        <p class="m-2" *ngIf="!restaurant?.message_event && restaurant?.nowclosed && !restaurant?.day_closed && restaurant?.preorder && !restaurant?.ordinabiledomani">
                            Disponibile dalle {{restaurant?.next_open}}
                        </p>
                        <p class="text-color-accent2 m-2" *ngIf="!restaurant?.message_event && restaurant?.nowclosed && !restaurant?.day_closed && restaurant?.preorder && restaurant?.ordinabiledomani">
                            Per domani
                        </p>
                        <p class="text-color-accent2 m-2" *ngIf="restaurant?.message_event">{{restaurant?.message_event}}</p>
    
                        <p class="text-color-dark m-2" *ngIf="cartData && cartData.order">
                            Consegna {{cartData.order.euro_delivery.toFixed(2)}} &euro;
                        </p>
                    </ng-container>
                    <ng-template #istakeaway>
                        <p class="text-color-accent m-2" *ngIf="!restaurant?.message_event_takeaway && !restaurant?.nowclosed_takeaway && !restaurant?.day_closed_takeaway">
                            Ritiro in 30 minuti
                        </p>
                        <p class="text-color-accent2 m-2" *ngIf="!restaurant?.message_event_takeaway && restaurant?.nowclosed_takeaway && !restaurant?.day_closed_takeaway && !restaurant?.preorder_takeaway">
                            Torno presto
                        </p>
                        <p class="text-color-accent2 m-2" *ngIf="!restaurant?.message_event_takeaway && restaurant?.day_closed_takeaway">Torno presto</p>
                        <p class="m-2" *ngIf="!restaurant?.message_event_takeaway && restaurant?.nowclosed_takeaway && !restaurant?.day_closed_takeaway && restaurant?.preorder_takeaway && !restaurant?.ordinabiledomani_takeaway">
                            Disponibile dalle {{restaurant?.next_open_takeaway}}
                        </p>
                        <p class="text-color-accent2 m-2" *ngIf="!restaurant?.message_event_takeaway && restaurant?.nowclosed_takeaway && !restaurant?.day_closed_takeaway && restaurant?.preorder_takeaway && restaurant?.ordinabiledomani_takeaway">
                            Per domani
                        </p>
                        <p class="text-color-accent2 m-2" *ngIf="restaurant?.message_event_takeaway">{{restaurant?.message_event_takeaway}}</p>
    
                    </ng-template>
                    <div class="label-fill m-2" *ngIf="restaurant?.interno" [innerHTML]="restaurant.interno"></div>
                    <p class="text-color-dark m-2 mt-5">Puoi consultare il libro degli allergeni direttamente in store</p>
                </div>
            </div>
            <!-- <app-separator></app-separator> -->
        </div>

        <div class="container">
            <app-menu-box [list]="list" id="collapseMenu" [ngbCollapse]="isCollapsedMenu" [search]="search" [searchbar]="searchbar" (searchQuery)="updateSearch($event)" [loader]="loaderMenu">
            </app-menu-box>
        </div>
    </div>
</section>
<app-footer-two [class]="'bg-img-gym bg-size'"></app-footer-two>
<app-custom-modal #customModal></app-custom-modal>